/**
 * Intent sent to the DoseSpot embed URL / launcher (mock UI only for now).
 * Replace demo footer actions with postMessage / SDK callbacks when integrated.
 */

/** Static mockup shown until the real iframe is wired. Add your file as `public/integrations/dosespot-embed-preview.png`. */
export const DOSESPOT_PREVIEW_IMAGE_PATH = '/integrations/dosespot-mock.png';

export type DoseSpotEmbedIntent = 'newRx' | 'refill' | 'discontinue';

/** Payloads the real embed would signal back to the host app on success. */
export type DoseSpotDemoCompletePayload =
  | { intent: 'refill'; medicationId: string }
  | {
    intent: 'discontinue';
    medicationId: string;
    status: 'Discontinued' | 'On Hold';
    note?: string;
  };
